var e,t;function r(){if(t)return e;t=1;return e=function(e){var t=new Date(e.getTime()),r=t.getTimezoneOffset();return t.setSeconds(0,0),6e4*r+t.getTime()%6e4}}export{r as __require};
//# sourceMappingURL=index.js.map
